import { createFileRoute } from '@tanstack/react-router';
import { EmployeeForm } from '@/pages/registry/employees/form/employee-form';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/registry/_layout/employees/new'
)({
  component: () => <EmployeeForm returnUrl={`${PROTECTED}${REGISTRY}`} />,
});
